import Dialog, { DialogBody, DialogTitle } from './Dialog';
import React from 'react';

export default function LoaderDialog({ data }) {
    return (
        <Dialog>
            {data.get('title') ? <DialogTitle>{data.get('title')}</DialogTitle> : null}
            <DialogBody>
                <div className="ajax-preloader" />
                <p className="text-center">{data.get('text')}</p>
            </DialogBody>
        </Dialog>
    );
}
